module.exports = __webpack_public_path__ + "static/media/icon-close.87435a9c.svg";